/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { a as g, b as h } from "./index.CU3WOwsM.js";
/*!
 * currency.js - v2.0.4
 * http://scurker.github.io/currency.js
 *
 * Copyright (c) 2021 Jason Wilson
 * Released under MIT license
 */
var b = {
  symbol: "$",
  separator: ",",
  decimal: ".",
  errorOnInvalid: !1,
  precision: 2,
  pattern: "!#",
  negativePattern: "-!#",
  format: C,
  fromCents: !1
}, m = function(r) {
  return Math.round(r);
}, d = function(r) {
  return Math.pow(10, r);
}, V = function(r, n) {
  return m(r / n) * n;
}, _ = /(\d)(?=(\d{3})+\b)/g, O = /(\d)(?=(\d\d)+\d\b)/g;
function s(e, r) {
  var n = this;
  if (!(n instanceof s))
    return new s(e, r);
  var t = Object.assign({}, b, r), i = d(t.precision), a = f(e, t);
  n.intValue = a, n.value = a / i, t.increment = t.increment || 1 / i, t.useVedic ? t.groups = O : t.groups = _, this.s = t, this.p = i;
}
function f(e, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, t = 0, i = r.decimal, a = r.errorOnInvalid, c = r.precision, l = r.fromCents, o = d(c), u = typeof e == "number", p = e instanceof s;
  if (p && l)
    return e.intValue;
  if (u || p)
    t = p ? e.value : e;
  else if (typeof e == "string") {
    var v = new RegExp("[^-\\d" + i + "]", "g"), y = new RegExp("\\" + i, "g");
    t = e.replace(/\((.*)\)/, "-$1").replace(v, "").replace(y, "."), t = t || 0;
  } else {
    if (a)
      throw Error("Invalid Input");
    t = 0;
  }
  return l || (t *= o, t = t.toFixed(4)), n ? m(t) : t;
}
function C(e, r) {
  var n = r.pattern, t = r.negativePattern, i = r.symbol, a = r.separator, c = r.decimal, l = r.groups, o = ("" + e).replace(/^-/, "").split("."), u = o[0], p = o[1];
  return (e.value >= 0 ? n : t).replace("!", i).replace("#", u.replace(l, "$1" + a) + (p ? c + p : ""));
}
s.prototype = {
  /**
   * Adds values together.
   * @param {number} number
   * @returns {currency}
   */
  add: function(r) {
    var n = this.intValue, t = this.s, i = this.p;
    return s((n += f(r, t)) / (t.fromCents ? 1 : i), t);
  },
  /**
   * Subtracts value.
   * @param {number} number
   * @returns {currency}
   */
  subtract: function(r) {
    var n = this.intValue, t = this.s, i = this.p;
    return s((n -= f(r, t)) / (t.fromCents ? 1 : i), t);
  },
  /**
   * Multiplies values.
   * @param {number} number
   * @returns {currency}
   */
  multiply: function(r) {
    var n = this.intValue, t = this.s;
    return s((n *= r) / (t.fromCents ? 1 : d(t.precision)), t);
  },
  /**
   * Divides value.
   * @param {number} number
   * @returns {currency}
   */
  divide: function(r) {
    var n = this.intValue, t = this.s;
    return s(n /= f(r, t, !1), t);
  },
  /**
   * Takes the currency amount and distributes the values evenly. Any extra pennies
   * left over from the distribution will be stacked onto the first set of entries.
   * @param {number} count
   * @returns {array}
   */
  distribute: function(r) {
    for (var n = this.intValue, t = this.p, i = this.s, a = [], c = Math[n >= 0 ? "floor" : "ceil"](n / r), l = Math.abs(n - c * r), o = i.fromCents ? 1 : t; r !== 0; r--) {
      var u = s(c / o, i);
      l-- > 0 && (u = u[n >= 0 ? "add" : "subtract"](1 / o)), a.push(u);
    }
    return a;
  },
  /**
   * Returns the dollar value.
   * @returns {number}
   */
  dollars: function() {
    return ~~this.value;
  },
  /**
   * Returns the cent value.
   * @returns {number}
   */
  cents: function() {
    var r = this.intValue, n = this.p;
    return ~~(r % n);
  },
  /**
   * Formats the value as a string according to the formatting settings.
   * @param {boolean} useSymbol - format with currency symbol
   * @returns {string}
   */
  format: function(r) {
    var n = this.s;
    return typeof r == "function" ? r(this, n) : n.format(this, Object.assign({}, n, r));
  },
  /**
   * Formats the value as a string according to the formatting settings.
   * @returns {string}
   */
  toString: function() {
    var r = this.intValue, n = this.p, t = this.s;
    return V(r / n, t.increment).toFixed(t.precision);
  },
  /**
   * Value for JSON serialization.
   * @returns {float}
   */
  toJSON: function() {
    return this.value;
  }
};
const P = (e) => {
  try {
    return g(`${e}`);
  } catch (r) {
    return console.error(r), g("DOP");
  }
}, S = (e) => {
  try {
    return h("currency", `${e.toUpperCase()}`, "symbol");
  } catch (r) {
    return console.error(r), h("currency", "DOP", "symbol");
  }
}, I = (e, r = 2) => s(e, { precision: r, pattern: "! #" }), x = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  currencyPattern: I,
  getCurrencyByISO: P,
  getSymbolByCurrency: S
}, Symbol.toStringTag, { value: "Module" }));
export {
  I as a,
  s as b,
  x as c,
  P as d,
  S as g
};
